import { Container } from './style'

export function CircleStyleArea() {
    return <Container />
}
